import classNames from 'classnames';

import FastDelivery from 'components/icons/FastDelivery';
import mealCardStyle from 'styles/shared/dashboardMealCard';

const LowShippingCard = ({ cardStyle = 'inline-flex flex-col rounded', priceDiff = '' }) => {
  return (
    <article
      className={classNames(
        'max-w-none',
        cardStyle,
        mealCardStyle.expanded,
        'h-full min-h-[250px] w-full items-center justify-center border-2 border-dashed border-green-110 text-center text-charcoal-80'
      )}
    >
      <>
        <FastDelivery className="iconXxl mx-auto" />
        <h4 data-testid="shipping-card-text" className="h4 w-full px-4 text-green-100">
          {`Save ${priceDiff} on shipping`}
        </h4>
        <h5 className="text text-charcoal-90">Add another meal to save.</h5>
      </>
    </article>
  );
};

LowShippingCard.propTypes = {
  cardStyle: PropTypes.string,
  priceDiff: PropTypes.string.isRequired,
};

export default LowShippingCard;
